import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import {
  API_URL,
  ILinkVerificationCodeValidationRequestDto,
  IVerificationCodeValidationResponseDto,
} from '@/dtos';

interface Body {
  hashId: string;
  email: string;
  code: string;
}

const useConfirmEmailQuery = () => {
  const { mutateAsync, isError, isLoading, isSuccess } = useMutation((body: Body) =>
    api.patch<IVerificationCodeValidationResponseDto, ILinkVerificationCodeValidationRequestDto>(
      API_URL.EMAILS_CONFIRMATION,
      {
        hash_id: body.hashId,
        email: body.email,
        code: body.code,
      }
    )
  );

  return {
    confirmUserEmail: mutateAsync,
    isLoading,
    isError,
    isSuccess,
  };
};

export default useConfirmEmailQuery;
